import styled from 'styled-components'

export const WhatsNewWrapper = styled.div`
  background-color: white;
  border-radius: 4px;
  padding: 12px;
  min-height: calc(100vh - 280px);
`
